<template>
	<v-bottom-sheet
		v-bind:value="isDisplay"
		v-on:input="onClose"
		:persistent="isPersistent"
		ref="sheet"
	>
		<slot></slot>
	</v-bottom-sheet>
</template>
<script>
import MouseState from '../classes/MouseState';
import MouseStateMachine from '../classes/MouseStateMachine';

export default {
	name: 'GBBottomPane',
	props: [
		"display",
		"persistent",
	],
	data() {
		let state_default = new MouseState({
			down: (e, next) => {
				if (!this.$refs.sheet)
					return;
				let dialog = this.$refs.sheet.$children[0];
				if (!dialog)
					return;
				let content = dialog.$refs.content;
				if (content && content.contains(e.target)) {
					next(state_downed);
				}
			},
		});
		let state_downed = new MouseState({
			up: (e, next) => {
				this.tmp_persistent = true;
				setTimeout(() => {
					this.tmp_persistent = false;
				}, 100);
				next(state_default);
			},
		});
		return {
			sm: new MouseStateMachine(state_default),
			tmp_persistent: false,
		};
	},
	methods: {
		onClose: function(e) {
			this.$emit('close', e);
		},
	},
	computed: {
		isDisplay : function () {
			return this.display;
		},
		isPersistent: function() {
			return this.persistent || this.tmp_persistent;
		},
	},
	mounted: function() {
		this.sm.bind(window);
	},
	beforeDestory: function() {
		this.sm.unbind();
	},
};
</script>
